import React, { useEffect, useState } from "react";
import UserService from "../services/user.service";
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { Box } from '@mui/system';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Typography } from "@mui/material";
import { Link } from 'react-router-dom';
import {UserDocuments, UserProjects } from "./_userDocuments";
import UserEditModal from "./_UserEditModal";
import CustomerManager from "./_customerManager";
import CommonDocuments from "./_commonDocuments";

const Dashboard = () => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    async function fetchCurrentUser() {
      try {
        const user = await UserService.getCurrentUser();
        setCurrentUser(user);
      } catch (error) {
        console.error("Error fetching current user:", error);
      }
    }

    fetchCurrentUser();
  }, []);

  if (!currentUser) {
    return null; // Alternativ kannst du einen Ladeindikator anzeigen
  }

  return (
    <Box sx={{ background: "#F0F2F5", py: 10 }}>
      <Container maxWidth="xl">
        <Grid container spacing={2}>
          {/* Linke Seite: Kontaktdaten */}
          <Grid item xs={12} lg={4}>
            <Paper elevation={1} sx={{ p: 3, mb: 3}}>
              <UserEditModal />
              <Typography variant="h6">Ihre Kontaktdaten</Typography>
              <table>
                <tbody>
                  <tr>
                    <td><strong>Name:</strong></td>
                    <td>{currentUser.firstname} {currentUser.lastname}</td>
                  </tr>
                  <tr>
                    <td><strong>Straße:</strong></td>
                    <td>{currentUser.adresse}</td>
                  </tr>
                  <tr>
                    <td><strong>Ort:</strong></td>
                    <td>{currentUser.zip} {currentUser.ort}</td>
                  </tr>
                  <tr>
                    <td><strong>E-Mail:</strong></td>
                    <td>{currentUser.email}</td>
                  </tr>
                  {currentUser.mobile && (
                    <tr>
                      <td><strong>Mobil:</strong></td>
                      <td>{currentUser.mobile}</td>
                    </tr>
                  )}
                  {currentUser.phone && (
                    <tr>
                      <td><strong>Tel:</strong></td>
                      <td>{currentUser.phone}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Paper>
            <CustomerManager />
          </Grid>

          {/* Rechte Seite: Upload und Dokumente */}
          <Grid item xs={12} lg={8}>
            <Grid container spacing={2}>
              {/* Ihre Unterlagen */}
              <Grid item xs={12}>
                <Paper elevation={1} sx={{ p: 3, textAlign: { xs: 'left', lg: 'center' } }}>
                  <Typography variant="h6">Ihre Projekte</Typography>
                  <UserProjects />
                  <Typography variant="h5" mb={2} mt={5}>Unterlagen einreichen</Typography>
                  <Grid container justifyContent="center">
                    <Grid item xs={12} sm={6} md={4}>
                      <Link to="/upload" style={{ textDecoration: 'none' }}>
                        <Paper elevation={3} sx={{ p: 3, textAlign: 'center', cursor: 'pointer' }}>
                          <FileUploadOutlinedIcon sx={{ fontSize: 40, mb: 3 }} />
                          <Typography>Zum Upload-Bereich</Typography>
                        </Paper>
                      </Link>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              
              {/* Unterlagen einreichen */}
              <Grid item xs={12}>
                <Paper elevation={1} sx={{ mb: 2, p: 3, textAlign: { xs: 'left', lg: 'center' } }}>
                  <CommonDocuments />
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Dashboard;
